/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import { useMediaQuery, useTheme } from '@mui/material';

/**
 * Phones get v4 as the Agent chat only: no desktop, dock, windows or
 * workspace, just the conversation full screen.
 */
export const useAgentOnlyLayout = () => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });
};
